(ns graph-ui.web.note-image
  "AN IMAGE A NOTE NAMES, drawn from the bytes the bus holds.

  ;; @feature F-graph-ui-v0-002-01-foam-markdown-vault
  ;; @adr     ADR-ikc-v3-096-01-the-bus-is-the-door

  George, IKC3-Bugs-20260928 item 9: \"Cannot paste image in a note\". A paste
  stores the image in the :attachments vault (ui.attachments/paste-note-image)
  and the block carries `![image](vault:attachments:<day>/<uuid>.<ext>)`.

  THE PICTURE COMES THROUGH THE BUS, NOT A SECOND HTTP ROUTE. The browser reads
  the :note-image source with :ui/read, so the one seam and its one
  authorisation cover the bytes too. The door serves the bundle and the public
  pages, and it asks for no principal. A route there would be a way to a
  person's files that the sign-in does not guard.

  WHY A NAMESPACE OF ITS OWN. graph-ui.web.markdown draws the image and knows no
  bus. graph-ui.web.core owns the bus and draws no markdown. Neither may require
  the other, so core hands the bus here once, at connect."
  (:require [reagent.core :as r]
            [clojure.string :as str]))

(defonce ^:private reader (atom nil))

;; {path \"data:…\" | :loading | :missing}. A stored image never changes, because
;; every paste gets a new name, so an answer is kept for the whole visit.
(defonce ^:private answers (r/atom {}))

(def prefix
  "The one vault a note's image may come from. The server enforces the same
   rule (ui.attachments/note-image-media); this only decides what to ASK for."
  "vault:attachments:")

(defn attachment-href?
  "PURE. Does a markdown image destination name a stored attachment?"
  [href]
  (str/starts-with? (str href) prefix))

(defn use-bus!
  "Give this namespace the bus to read through. Called by graph-ui.web.core on
   every connect, so a reconnect replaces the old bus."
  [bus]
  (reset! reader
          (fn [path on-value]
            (js-invoke bus "dispatch"
                       {:type :ui/read :source :note-image :args {:path path}}
                       on-value))))

(defn- ask! [path]
  (when-let [read @reader]
    (when-not (contains? @answers path)
      (swap! answers assoc path :loading)
      (read path (fn [v]
                   (swap! answers assoc path
                          (if (and (string? v) (str/starts-with? v "data:"))
                            v
                            :missing)))))))

(defn note-image
  "One image of a note. `href` is the markdown destination, `alt` its text.
   An attachment is read through the bus. Any other destination draws as the
   browser would draw it, so an ordinary https image still works."
  [href alt]
  (if-not (attachment-href? href)
    [:img {:src href :alt (or alt "") :class "max-w-full h-auto my-1 rounded"}]
    (do (ask! href)
        (let [v (get @answers href)]
          (if (string? v)
            [:img {:src v :alt (or alt "") :class "max-w-full h-auto my-1 rounded"
                   :data-attachment href}]
            ;; A RESERVED BOX, NOT NOTHING. A reader must know a picture is
            ;; here while it loads, and after a refusal.
            [:span {:class "inline-block px-2 py-1 my-1 rounded text-xs text-[var(--faint)] border border-dashed border-[var(--border)]"
                    :data-attachment href}
             (if (= v :missing) (str "image not found: " href) (str "image: " (or alt "loading…")))])))))
